import React, { useState } from 'react'
import Image from 'react-bootstrap/Image'
import { v4 as uuid } from "uuid";

function News() {

    const [images, setImage] = useState([
        {
            id: uuid(),
            image: 'https://i.playground.ru/i/screenshot/176300/paragon_the_overprime.jpg',
            text: 'Новая игра Paragon: The Overprime как вам?',
        },
        {
            id: uuid(),
            image: 'https://img.freepik.com/free-photo/worker-reading-news-with-tablet_1162-83.jpg?w=1380&t=st=1675031013~exp=1675031613~hmac=721934abe6ab4345522afca1e77c2e7088df979efa355c89a1723ea3ba7200b3',
            text: 'Версия сайта 1.4',
        },
        {
            id: uuid(),
            image: 'https://i.ytimg.com/vi/GfcVfgpCZOY/maxresdefault.jpg',
            text: 'Найдена новая бесплатная интересная игра в Steam , давайте же попробуем?',
        },
        {
            id: uuid(),
            image: 'http://pic.rutubelist.ru/video/a4/31/a43116c5cc755eb8828d2918e8307de1.jpg',
            text: 'Появилось небольшая сводка правил minecraft и добавлены новые предметы в магазин на сервере ',
        },
        {
            id: uuid(),
            image: 'https://pic.rutubelist.ru/video/0c/dd/0cddbd1cc8357739ce57f87473e70746.png',
            text: 'Появились новые игры рекомендуемые сообществом WG, сегодня будем тестировать новую игру в 20:30 по МСК',
        },
        {
            id: uuid(),
            image: 'https://i.ytimg.com/vi/bhx4y2oW0Ac/maxresdefault.jpg',
            text: 'Обновление Minecraft - добавилось множество плагинов! Удачной вам игры!',
        },
        {
            id: uuid(),
            image: 'https://phonoteka.org/uploads/posts/2022-09/1663767832_26-phonoteka-org-p-foni-diskord-krasivo-35.jpg',
            text: 'Обновление на Discord сервере , теперь вы можете менять цвет ника в сообществе WorldGames в разделе ==> роли ( Доступно только пупсикам), так же выбрать игру в которой вы хотите найти напарника! ( Доступно всем ролям )',
        },
        {
            id: uuid(),
            image: 'https://i.ytimg.com/vi/I-8SJZ7VRuk/maxresdefault.jpg',
            text: 'Сервер Minecraft запущен и добавлен плагин Factions - СРАЖАЙСЯ и УБИВАЙ! ',
        },
        {
            id: uuid(),
            image: 'https://gamersguide.ru/wp-content/uploads/2022/10/word-image-7631-8.jpeg',
            text: ' Добавлены новые моды на сервер: More Armor , Display Food Values , Global Positions -Remapped ',
        },
        {
            id: uuid(),
            image: 'https://otkritkis.com/wp-content/uploads/2021/10/foto-pozdravlenija-s-novyj-godom_rect_23f358a6da2eb6fb54e5794f673a53e8.jpg',
            text: 'WorldGames поздравляет всех с новым годом! Желаем встретить новую жизнь с распростёртыми объятиями и радостью! Пусть счастьем и любовью, гармонией и миром, благополучием и здоровьем будет наполнен весь новый год, а каждый день пускай будет праздником! ',
        },
        {
            id: uuid(),
            image: 'https://sun9-6.userapi.com/impf/NDx1RMAeHHFsCDACyPzkO0WZuERvMSDu0Eim8A/evuU2xgUmTg.jpg?size=0x0&quality=90&proxy=1&sign=8f2d20a4910f8428261b63e3494cabf0&c_uniq_tag=J4mxOc55PnexetiembUmlWJqu_pfVa3gV0OlVFJ0ddg&type=video_thumb',
            text: 'WorldGames открывает новый сервер по игре Dont Starve Together версией 1.1',
        },
        {
            id: uuid(),
            image: 'https://coop-land.ru/uploads/posts/2021-06/1624971626_bez-imeni-1.jpg',
            text: 'Valheim сервера перешли на новое оборудование теперь можно играть без VPN для жителей Украины и Европы',
        },
        {
            id: uuid(),
            image: 'https://flatmedia.ru/wp-content/uploads/2015/03/device-composition-4b-variant-11.png',
            text: 'Версия сайта 1.3',
        }
    ])


    return (
        <div>
            {images.map((image) => (
                <div>
                    <div className='c_c'>
                        <Image className='Tr_block_img' src={image.image}></Image>
                    </div>
                    <div className='All_block_one'>
                        <p className='All_text_block_one'>{image.text}</p>
                    </div>
                    <div className='Tr_stick'></div>
                </div>
            ))}
        </div>
    )
}
export default News
